import { useSessionContext } from "@/contexts/SessionContext";
import { useTeleconsultoriaContractContext } from "@/contexts/TeleconsultoriaContractContext";
import { useTeleconsultoriaProfile } from "../../profile/TeleconsultoriaProfileContext";

const MANAGING_ROLES = ["manager", "owner"];

/** Gestor/dono, na visão profissional, com a extensão ativa. */
function useIsManagingWithContract(): boolean {
  const { access } = useSessionContext();
  const { contractTeleconsultoria } = useTeleconsultoriaContractContext();
  const roles: string[] = access?.roles ?? [];
  const hasManagingRole = roles.some((role) => MANAGING_ROLES.includes(role));
  return access?.type === "professional" && Boolean(contractTeleconsultoria) && hasManagingRole;
}

/**
 * Gestão de afiliações: só a organização prestadora (extensão ativa)
 * e só para gestor/dono. Profissional comum não vê a aba.
 * Afiliada nunca gerencia afiliações, mesmo se tiver ativado a extensão.
 */
export function useCanManageTeleconsultoriaAffiliations(): boolean {
  const { profile } = useTeleconsultoriaProfile();
  return useIsManagingWithContract() && profile.kind === "provider";
}

/**
 * Escolher o papel da clínica ("Prestar" ou "Receber"): mesma regra de gestor/dono
 * com a extensão, valendo só enquanto não há relação (perfil "unassigned").
 */
export function useCanSetupTeleconsultoria(): boolean {
  const { profile } = useTeleconsultoriaProfile();
  return useIsManagingWithContract() && profile.kind === "unassigned";
}
